/*
app-bootstrap.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/**
 * This file bootstraps angular onto the window.document node
 * NOTE: the ng-app attribute should not be used in index.html when using ng.bootstrap
 */
define('modules/shell/app-bootstrap',[
    'angular',
    'jquery',
    'system-config',
    './main'
], function (angular, $, systemConfig) {
    'use strict';

    var getApiGatewayURL = function (response) {
        var jsonEndPoints = typeof (response) === 'string' ? JSON.parse(response).endpoints : response.endpoints;

        //Store the request header in to session storage for later use.
        window.sessionStorage.setItem('X-Endpoints', JSON.stringify(jsonEndPoints));
    };

    var getAppConfig = function (successCallback, errorCallback) {
        $.ajax({
            async: true,
            type: 'get',
            url: 'appConfig.json',
            success: successCallback,
            error: errorCallback
        });
    };

    var bootstrapAngularModules = function () {
        var modules = systemConfig.appModules.concat('uaf.appshell');
        var start = new Date();
        var end;
        var style = 'color: blue; background: #e0e0e0';

        console.log('%capp-bootstrap - bootstraping angular modules: ' + modules.length + ' - ' + modules, style);
        console.log('%capp-bootstrap - bootstraping at: ' + start.getTime() + ' - ' + start.toJSON(), style);

        angular.bootstrap(document, modules);

        end = new Date();
        console.log('%capp-bootstrap - angular modules bootstrapped at: ' + end.getTime() + ' - ' + end.toJSON(), style);
        console.log('%capp-bootstrap - bootstrap duration: ' + (end.getTime() - start.getTime()) + ' - ' + ((end.getTime() - start.getTime()) / 1000), style);
    };

    if (systemConfig) {

        getAppConfig(function (response) {
            getApiGatewayURL(response);
            bootstrapAngularModules();
        }, function (error) {
            console.log('ERROR: Failed to get appConfig.json. Application bootstrapping failed: ' + error);
        });

    } else {
        console.error('ERROR: system config is missing');
    }

});

